import { render, staticRenderFns } from "./cart-bar.vue?vue&type=template&id=5d5ce5da&"
import script from "./cart-bar.vue?vue&type=script&lang=js&"
export * from "./cart-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports